<div class="container-fluid">
    <div class="card border-0 no-shadow mb-3 p-0">
        <div class="card-header text-white">
            Receive Sample
        </div>
        <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="large" color="#fff" type="ball-spin-clockwise"
            [fullScreen]="true">
        </ngx-spinner>
        <div class="card-body p-4">
            <div class="d-flex pt-2 justify-content-between">

                <div class="float-left">
                    <button class="back-button" (click)="backButton()">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                </div>

            </div>

            <div class="d-flex">
                <div class="float-left">
                    <div class="input-group">
                        <input type="search" class="form-control" placeholder="Search" [(ngModel)]="searchTexts"
                            aria-label="Search" aria-describedby="search-addon"
                            style="border: none !important;background: #efefef;" />
                        <button type="button" class="btn ">
                            <i
                                class="fa fa-search" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="mt-2 tabs-div">
       
                <div class="float-right">
                    <button (click)="generateExcel()" class="export-excel-button">
                        Export
                    </button>
                </div>
            </div>

            <div class="container table-responsive mt-3 p-0" >
                <table class="table table-striped">
                    <thead class="thead" >
                        <tr >
                            <th scope="col">
                                <span>S.No.</span>
                            </th>
                            <th scope="col" [appSort]="orgList" data-order="desc" data-name="qrcode_unique">
                                <span>Sample Unique  Number #</span>&nbsp;<span><img
                                        src="../../../../../../assets/sort-icon.png"></span>
                            </th>
                            <th scope="col" [appSort]="orgList" data-order="desc" data-name="morphineValue">
                                <span>Morphine %</span>&nbsp;<span><img
                                        src="../../../../../../assets/sort-icon.png"></span>
                            </th>
                            <th scope="col" [appSort]="orgList" data-order="desc" data-name="consistency">
                                <span>Consistency</span>&nbsp;<span><img
                                        src="../../../../../../assets/sort-icon.png"></span>
                            </th>
                            <th scope="col" [appSort]="orgList" data-order="desc" data-name="morphineODB">
                                <span>Morphine(ODB)</span>&nbsp;<span><img
                                        src="../../../../../../assets/sort-icon.png"></span>
                            </th>

                            <th scope="col" *ngIf="stage === 'Testing in Progress'">
                                <span>Status</span>&nbsp;<span><img src="../../../../../../assets/sort-icon.png"></span>
                            </th>
                            <th scope="col" *ngIf="stage === 'Testing in Progress'">
                                <span>Action</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody >

                        <tr *ngFor="let org of orgList | searchBySequence:searchTexts | paginate: config  ; let i=index;" >
                            <td class="first-td">{{i+1}}</td>
                            <td class="middle-td">{{org.qrcode_unique}}</td>
                            <td class="middle-td">{{org.Morphine}}</td>
                            <td class="middle-td">{{org.Consistency}}</td>
                            <td class="middle-td">{{org.Morphine_ODB}}</td>
                            <td *ngIf="stage === 'Testing in Progress'" class="middle-td">{{org.samplingStatus}}</td>
                            <td *ngIf="stage === 'Testing in Progress'" class="last-td">
                                <p class="d-flex m-0">

                                    <a class="button button-small view-button pt-0"   
                                        (click)="edit(org)">
                                        Edit
                                    </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-content-end">
                    <pagination-controls (pageChange)="pageChange($event)" (pageBoundsCorrection)="pageChange($event)"
                        maxSize="6" directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                        nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page">
                    </pagination-controls>
                </div>
            </div>

            


        </div>


    </div>



</div>